/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCategoryMinus = createReactComponent("outline", "category-minus", "IconCategoryMinus", [["path", { "d": "M4 4h6v6h-6zm10 0h6v6h-6zm-10 10h6v6h-6zm10 3h6", "key": "svg-0" }]]);

export { IconCategoryMinus as default };
//# sourceMappingURL=IconCategoryMinus.mjs.map
